import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  margin-right: 10px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 500;
  font-family: "Inter";
  flex-shrink: 0;
  display: flex;
  position: relative;
  align-items: center;
  --text-color: var(--grey-1);
  background-color: var(--document-background-hover);
  color: var(--text-color);
  padding: 0 8px;
  height: 35px;

  & > svg {
    path {
      fill: var(--text-color);

      &:not(:first-child) {
        stroke: var(--text-color);
      }
    }
  }

  &.connected {
    .labels {
      padding: 6px 7px 6px 2px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 106px;
    }

    .submenu-control {
      padding: 8px 9px;
      border-left: none;
    }
  }

  .labels {
    flex-grow: 2;
    padding: 8px;
    cursor: pointer;
    padding: 6px 7px 6px 2px;

    .action-label {
      font-size: 15.5px;
      margin-bottom: 2px;
    }

    .mode-label {
      font-size: 10px;
      font-weight: 600;
      letter-spacing: 0.03em;
    }
  }

  .submenu-control {
    display: flex;
    padding: 10px;
    position: relative;
    border-left: 1.5px solid rgba(255, 255, 255, 0.3);
    cursor: pointer;

    svg {
      margin-top: 3px;
      margin-right: 4px;
      path {
        fill: var(--text-color);
      }
      width: 14px;
    }
  }

  .submenu {
    position: absolute;
    left: 0;
    top: 120%;
    background-color: var(--menu-color);
    padding: 14px 8px 8px 8px;
    border-radius: 13.3333px;
    box-shadow: var(--default-drop-shadow);
    width: 100%;
    min-width: 170px;
    display: flex;
    flex-direction: column;
    z-index: 19001;
    max-height: min(calc(100vh - 200px), 500px);
    overflow-y: auto;

    .scene {
      padding: 6px;
      color: var(--grey-0);
      cursor: pointer;

      &.element {
        &:hover {
          background: var(--menu-color-hover);
          border-radius: 6px;
        }
      }

      &.main-heading {
        margin-bottom: 8px;
        cursor: unset;
      }
    }
  }

  .intervention {
    border-radius: 17px;
    background: var(--menu-color);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15), 0px 0px 1px 0px rgba(0, 0, 0, 0.25);
    padding: 20px;
    position: absolute;
    top: 50px;
    right: 0;
    width: 265px;
    color: var(--grey-0);

    p {
      line-height: 1.3em !important;
    }

    .actions {
      display: flex;
      justify-content: flex-end;
      button {
        border: 2px solid transparent;
        margin-left: 8px;
        border-radius: 10px !important;
        height: 41px !important;
        padding: 5px 15px !important;

        &.secondary {
          border: 2px solid var(--primary-cta-high-contrast);
        }
      }
    }
  }
`;
